import type { OpenAPI } from "simplydo/interfaces";
import type { ChallengeWithCoverImage } from "simplydo/interfaces/types/challengeTypes";
import type { IdeaWithCoverImage } from "simplydo/interfaces/types/ideaTypes";

/** Runtime `/tags/full` collections are arrays; OpenAPI schema models them as single objects. */
export type TagExplorerIdea = IdeaWithCoverImage & {
  _id: string;
  name: string;
  isSubmitted?: boolean;
  submittedAt?: string;
  updatedAt: string;
};

export type TagExplorerChallenge = Pick<
  ChallengeWithCoverImage,
  "_id" | "name" | "stage" | "deadline" | "coverImage" | "bannerImage"
>;

export type TagExplorerUser = OpenAPI.Schemas["users"] & {
  profile: NonNullable<OpenAPI.Schemas["users"]["profile"]>;
  lastSeenAt: string;
};

export type TagExplorerData = {
  tags: OpenAPI.Schemas["Tag"][];
  collections: {
    ideas?: TagExplorerIdea[];
    challenges?: TagExplorerChallenge[];
    users?: TagExplorerUser[];
  };
};

export const emptyTagExplorerData = (): TagExplorerData => ({
  tags: [],
  collections: {},
});
